export default __webpack_public_path__ + "navigation-examples-route-deserialize-v1-960-f112ee23aa792f88dea13398dad369af.webp";